var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2034 4.90409C11.3925 5.15323 11.6872 5.29956 12 5.29956C12.3128 5.29956 12.6075 5.15323 12.7966 4.90409C13.4435 4.05168 14.4731 3.5 15.6364 3.5H20.5C20.7761 3.5 21 3.72386 21 4V17.3C21 17.5761 20.7761 17.8 20.5 17.8H14.7273C13.4242 17.8 12.3168 18.6828 12 19.891C11.6832 18.6828 10.5758 17.8 9.27273 17.8H3.5C3.22386 17.8 3 17.5761 3 17.3V4C3 3.72386 3.22386 3.5 3.5 3.5H8.36364C9.52691 3.5 10.5565 4.05168 11.2034 4.90409Z",
    stroke: "white",
    strokeOpacity: 0.56,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.548a6b0bc863a02a2926aa5158a57ff3.svg";
export { ForwardRef as ReactComponent };